/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable indent */
/* eslint-disable class-methods-use-this */
// eslint-disable-next-line object-curly-newline
import {
  getFirestore,
  getDocs,
  getDoc,
  setDoc,
  deleteDoc,
  doc,
  collection,
  query,
  DocumentData,
  DocumentSnapshot,
} from "firebase/firestore";
import Config from "@/config/Config";
import { getFunctions, httpsCallable } from "firebase/functions";
import { EventManager } from "@models/EventManager";

class EventManagerDataService {
  eventCollectionName = "events";

  managerCollectionName = "managers";

  async getManagers(eventId: string): Promise<EventManager[]> {
    const db = getFirestore();

    const eventDoc = doc(db, this.eventCollectionName, eventId);

    const managersQuery = query(collection(eventDoc, this.managerCollectionName));

    const data = await getDocs(managersQuery);
    const results: EventManager[] = [];

    const managerPromises: Promise<DocumentSnapshot<DocumentData>>[] = [];
    data.forEach((item) => {
      managerPromises.push(getDoc(item.ref));
    });

    const participantDocumentSnapshots = await Promise.all(managerPromises);
    participantDocumentSnapshots.forEach((managerDoc) => {
      results.push({ ...managerDoc.data(), id: managerDoc.id } as EventManager);
    });
    return results;
  }

  async saveManager(eventId: string, manager: EventManager): Promise<EventManager> {
    const db = getFirestore();
    const eventDoc = doc(db, this.eventCollectionName, eventId);
    const managerDoc = doc(eventDoc, this.managerCollectionName, manager.id);

    await setDoc(managerDoc, manager);
    return manager;
  }

  async deleteManager(eventId: string, managerId: string): Promise<void> {
    const db = getFirestore();
    const eventDoc = doc(db, this.eventCollectionName, eventId);
    const managerDoc = doc(eventDoc, this.managerCollectionName, managerId);
    await deleteDoc(managerDoc);
  }

  async eventManagerInviteRespond(eventId: string, code: string, accepted: boolean) {
    const functions = getFunctions();
    const eventManagerInviteRespondFunc = httpsCallable(
      functions,
      Config.functions.EventManagerInviteRespond
    );

    const result = (await eventManagerInviteRespondFunc({
      eventId,
      code,
      accepted,
    })) as any;

    if (result?.data?.error) {
      throw result;
    }
  }

  warmup() {
    const functions = getFunctions();
    const eventManagerInviteRespondFunc = httpsCallable(
      functions,
      Config.functions.EventManagerInviteRespond
    );

    eventManagerInviteRespondFunc({
      warmup: true,
    });
  }
}

export default new EventManagerDataService();
